module.exports = __webpack_public_path__ + "static/img/buefy.1d65c18.png";


//////////////////
// WEBPACK FOOTER
// ./docs/assets/buefy.png
// module id = 907
// module chunks = 0 2 300